import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            clipRule="evenodd"
            d="M2.5 3C1.67157 3 1 3.67157 1 4.5V11.5C1 12.3284 1.67157 13 2.5 13H13.5C14.3284 13 15 12.3284 15 11.5V4.5C15 3.67157 14.3284 3 13.5 3H2.5ZM2 4.67828V11.5C2 11.7761 2.22386 12 2.5 12H13.5C13.7761 12 14 11.7761 14 11.5V4.67828L9.01359 9.24916C8.4401 9.77485 7.5599 9.77485 6.98641 9.24916L2 4.67828ZM13.2601 4H2.73995L7.66214 8.51201C7.8533 8.68724 8.1467 8.68724 8.33786 8.51201L13.2601 4Z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);

export default Icon;
